import styled from "styled-components";
import Button from "./Button";

export const BlueButton = styled(Button)`
    background-color: #049dfc;
`;


// WEBPACK FOOTER //
// ./src/components/Button/BlueButton.js